import { Tooltip as RTooltip } from "radix-ui";
import type { ReactElement, ReactNode } from "react";

export const TooltipProvider = RTooltip.Provider;

/** A hint for pointers and keyboards. Touch screens do not show it, so nothing essential may live only here. */
export function Tooltip({ content, children, side }: { content: ReactNode; children: ReactElement; side?: "top" | "right" | "bottom" | "left" }) {
  return (
    <RTooltip.Root>
      <RTooltip.Trigger asChild>{children}</RTooltip.Trigger>
      <RTooltip.Portal>
        <RTooltip.Content side={side} sideOffset={6} collisionPadding={8} className="z-50 max-w-64 rounded-sm bg-fg px-2.5 py-1.5 text-xs font-medium text-bg shadow-raised data-[state=delayed-open]:animate-fade-in">
          {content}
        </RTooltip.Content>
      </RTooltip.Portal>
    </RTooltip.Root>
  );
}
